// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1gHp7","header":"ClearentDisclaimer_header__2w73C","inner":"ClearentDisclaimer_inner__24nHw"};